import { ScriptAPI } from './ScriptAPI';

export class Command {
    static fromString(text) {
        let split = text.split('(');
        return new Command(
            ScriptAPI.getFuncByName(split[0]),
            split[1].replace(')', '').replace(/\s+/g, '').split(','),
            text
        );
    }

    constructor(func, args, text) {
        this.func = func;
        this.args = args;
        this.text = text;
    }

    execute(context) {
        console.log(context.id + ' >>> ' + this.text);
        return this.func.apply(context, this.args);
    }

    toString() {
        return this.text || this.func.name + '(' + this.args.join(', ') + ')';
    }
}
